// extracted by mini-css-extract-plugin
export default {"container":"generalInput_container__IFvCb"};